import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useCloseDialog } from '@sorare/core/src/hooks/navigation/useCloseDialog';
import { useDialogParam } from '@sorare/core/src/hooks/navigation/useDialogParam';

import { PrimaryBuyFlow } from '#src/components/primaryBuy/PrimaryBuyBuyField/PrimaryOfferBuyFieldWrapper/PrimaryBuyFlow/index.tsx';

export const StandalonePrimaryBuyFlow = () => {
  const offerId = useDialogParam(DialogKey.primaryOffer);
  const closeDialog = useCloseDialog();

  if (!offerId) return null;

  const onClose = () => {
    closeDialog(DialogKey.primaryOffer);
  };

  return (
    <PrimaryBuyFlow
      offerId={offerId}
      onClose={onClose}
      onBuyConfirmationClose={onClose}
    />
  );
};
